import { __rest, __assign } from './../external_lib/tslib/tslib.es6.js';
import React__default from 'react';
import classNames from './../external_lib/classnames/index.js';

function Icon(_a) {
    var svg = _a.svg, className = _a.className, props = __rest(_a, ["svg", "className"]);
    var getImage = function (_props) {
        if (typeof svg === 'function') {
            return encodeURIComponent(svg(_props));
        }
        return "";
    };
    return (React__default.createElement("img", __assign({ className: classNames(className, 'internal-icon'), src: "data:image/svg+xml;utf8,".concat(getImage(props)), width: 16, height: 16 }, props)));
}

export { Icon as default };
//# sourceMappingURL=Icon.js.map
